export default {"src":"/_next/static/media/walletconnect-circle-white.14af0a6f.svg","height":512,"width":512};